import styled from '@emotion/styled';
import React from 'react';
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';
import { ModalSidebarContent } from './index';

type Props<T extends FieldValues> = {
  body: React.ReactNode;
  footer?: React.ReactNode;
  footerClassName?: string;
  form: UseFormReturn<T>;
  onSubmit: SubmitHandler<T>;
};

const Form = styled('form')({
  display: 'contents',
});

export const ModalSidebarFormContent7 = <T extends FieldValues>({
  form,
  onSubmit,
  footer,
  footerClassName,
  body,
}: Props<T>) => (
  <FormProvider {...form}>
    <Form onSubmit={form.handleSubmit(onSubmit)}>
      <ModalSidebarContent
        body={body}
        footer={footer}
        footerClassName={footerClassName}
      />
    </Form>
  </FormProvider>
);
